import { useContext } from 'react'

import { ModalContext } from './ModalApi.components'

export const useShowModal = () => {
	const { show } = useContext(ModalContext)
	return show
}
